import WithLink from "features/common/components/WithLink";
import PrimaryButtonGreen from "./PrimaryButtonGreen";

export default WithLink(PrimaryButtonGreen);
